function showToast(message, type = "success") {
  const container = document.getElementById("toast-container");
  const toast = document.createElement("div");
  const bgClass = {
    success: "bg-success",
    error: "bg-danger",
    alert: "bg-warning",
    info: "bg-info",
    notice: "bg-success" // 'notice' は 'success' として扱う
  }[type] || "bg-primary";

  toast.className = `toast align-items-center text-white ${bgClass} border-0 show`;
  toast.setAttribute("role", "alert");
  toast.setAttribute("aria-live", "assertive");
  toast.setAttribute("aria-atomic", "true");
  toast.style.minWidth = "200px";
  toast.style.marginBottom = "0.5rem";

  toast.innerHTML = `
    <div class="d-flex">
      <div class="toast-body">${message}</div>
      <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
    </div>
  `;

  container.appendChild(toast);

  setTimeout(() => {
    toast.classList.remove("show");
    toast.classList.add("hide");
    setTimeout(() => container.removeChild(toast), 300);
  }, 3000);
}

function renderFlashToast() {
  const container = document.getElementById("toast-container");
  if (!container) return;

  container.innerHTML = '';

  const flash = JSON.parse(document.getElementById("flash-data")?.dataset?.flash || '{}');

  Object.entries(flash).forEach(([type, message]) => {
    let text = "";

    if (typeof message === "string") {
      text = message;
    } else if (Array.isArray(message)) {
      text = message.join("\n");
    } else {
      text = String(message);
    }

    const trimmedMessage = text.replace(/^(notice|alert|info|error)[,、:：\s]+/i, "").trim();
    showToast(trimmedMessage, type);
  });
}

window.showToast = showToast;
document.addEventListener("turbo:load", renderFlashToast);
